module.exports = __webpack_public_path__ + "static/media/clients-04.57fc97e6.svg";